<template>
    <div class="container"  v-loading="invoiceLoading">

        <div class="nav_header">
            <h2>申请发票</h2>
        </div>
     

        <!-- <el-table  :data="tableData" style="width: 100%"  >

          <el-table-column prop="order_no" label="订单号"  width="200"></el-table-column>
          <el-table-column prop="amount" label="充值金额"  width="200"></el-table-column>
          <el-table-column prop="channel_text" label="充值渠道"   width="200"></el-table-column>
          <el-table-column prop="subject" label="充值说明"  width="200"></el-table-column>
          <el-table-column prop="paid_at" label="充值状态"  width="200"></el-table-column>
     
        </el-table> -->

        <div v-if="invoice_status==1" class="invoice-tips">
            <div class=""><i class="iconfont icon-shenhezhong"></i></div>
             <white-space/>
            <div>
                当前的发票信息正在审核中，请等待工作人员审核。如有疑问，请联系客服人员。    
            </div>    
            <white-space/>
            <el-button plain @click="$router.push('/finance/invoice/create')">查看我提交的信息</el-button>
        </div> 
        <div v-if="invoice_status==0" class="invoice-tips">
            <template  v-if="invoiceData.invoice_msg">
                <el-alert
                    :title="invoiceData.invoice_msg"
                    :closable="false"
                    >
                
                </el-alert>
                <white-space/>
            </template>


            <div class=""><i class="el-icon-edit-outline"></i></div>
            <white-space/>
            <div>
                申请发票需要提供公司抬头等信息，请先补充并提交。
            </div>    
            <white-space/>
            <el-button plain @click="$router.push('/finance/invoice/create')" type="primary">完善我的发票信息</el-button>
        </div>

        <div v-if="invoice_status==-1" class="invoice-tips">
            <i class="iconfont icon-fapiao"></i>
            <white-space/>
            <div>尚未设置发票信息，请先创建用于开票的发票信息。</div>
            <white-space/>
            <el-button plain @click="$router.push('/finance/invoice/create')" icon="iconfont icon-arrowsrightline" type="primary">前往创建发票信息</el-button>
        </div>


        <el-steps :active="step" finish-status="success" simple v-if="rechargeData.length">
            <el-step title="1、选择需要开票的订单"></el-step>
            <el-step title="2、确认发票信息和地址"></el-step>
        </el-steps>

        <white-space/>
        
        <template v-if="invoiceData.invoice_status==2">
            <template v-if="step==1" >
                <el-table
                    v-if="rechargeData.length"
                    :data="rechargeData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        label="订单号"
                        prop="order_no"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="amount"
                        label="充值金额"
                        align="center"
                        width="120">
                        <template slot-scope="scope">
                            {{scope.row.amount}}元
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="amount"
                        label="可开票金额"
                        align="center"
                        width="120">
                        <template slot-scope="scope">
                            {{scope.row.amount-scope.row.amount_refunded}}元
                        </template>
                    </el-table-column>
                
                    <el-table-column
                        prop="paid_at"
                        align="right"
                        label="充值时间">
                        <template slot-scope="scope">
                            {{ scope.row.paid_at|dateformat('YYYY-MM-DD HH:mm')}}
                        </template>
                    </el-table-column>
                </el-table>

                <Empty v-if="!rechargeData.length" text="没有任何可供开票的充值订单"/>

                <div v-if="selected"> <white-space/>已选择<span class="number">{{selected}}</span>条充值记录，总计<span class="number">{{selectedTotal}}</span>元</div>

                <white-space/>

                <el-button @click="step=2" v-if="selected" type="primary">下一步，确认邮寄地址以及发票信息</el-button>
            </template>   

            <template v-if="step==2">
                <h3>发票信息确认</h3>
                <el-card class="box-card" shadow="never">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td>发票类型</td>
                                <td>{{invoiceData.invoice_type_text}}</td>
                            </tr>
                            <template v-if="invoiceData.invoice_type=='special' || invoiceData.invoice_type=='normal'">
                                <tr>
                                    <td>公司抬头</td>
                                    <td>{{invoiceData.title}}</td>
                                </tr>
                                <tr>
                                    <td>纳税人识别码</td>
                                    <td>{{invoiceData.id_code}}</td>
                                </tr>
                                <template v-if="invoiceData.invoice_type=='special'">
                                    <tr>
                                        <td>注册地址</td>
                                        <td>{{invoiceData.reg_address}}</td>
                                    </tr>
                                    <tr>
                                        <td>对公账号开户行</td>
                                        <td>{{invoiceData.public_bank_name}}</td>
                                    </tr>
                                    <tr>
                                        <td>对公账号</td>
                                        <td>{{invoiceData.public_bank_no}}</td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>   
                </el-card>     

                <white-space/>   

                <h3>选择邮寄地址</h3>
                <el-card class="box-card" shadow="never" v-if="addressData.length">
                    <div v-for="(item,index) in addressData" :key="index" class="radio">
                        <el-radio v-model="addressId" :label="item.id" >{{item.address}}，收件人：{{item.name}}，手机号码：{{item.mobile}}</el-radio>
                    </div>
                </el-card>

                <el-button @click="addressVisible=true" type="text">创建新的邮寄地址</el-button>

                <white-space/>

                <div v-if="invoiceData.invoice_type!='receipt'">    
                    <el-checkbox v-model="agree">同意从您的账户中扣除开票所需的6%税点，合计税额{{Math.floor(taxAmound* 100) / 100}}元（开票金额/1.06x0.06）</el-checkbox>
                    <white-space/>
                </div>

                <el-button @click="step=1" icon="el-icon-back" :disabled="submitting">返回上一步</el-button>

               


                <template v-if="invoiceData.invoice_type=='receipt'">
                     <el-button @click="handleSubmit" type="primary" v-if="addressId" :disabled="submitting">提交开票申请</el-button>
                </template>
                <template v-else>
                     <el-button @click="handleSubmit" type="primary" v-if="addressId&&agree" :disabled="submitting">提交开票申请</el-button>
                </template>

            </template>   

        </template>

        <AddressCreate :visible="addressVisible" @addressHidden="()=>{addressVisible = false}" @loadAddress="this.loadAddress"/>

    </div>
</template>      

<script>

import AddressCreate from '../personal/AddressCreate';
export default {
    data(){
        return{
            invoiceLoading:true,
            invoice_status: -1,
            addressVisible:false,
            rechargeData:[],
            addressData:[],
            selected:0,
            selectedTotal:0,
            step:1,
            addressData:[],
            invoiceData:{},
            form:{},
            taxAmound:'',
            agree:false,
            submitting:false,
            addressId:null,
            selectedOrder:[]
        }
    },
    created(){
        this.$store.commit('changeOwnActive', 'finance-invoice')
        this.loadInvoice();
    },
    watch:{
        selectedTotal(v){
            this.taxAmound = (v/1.06)*0.06
        }
    },
    components:{AddressCreate},
    methods:{
        loadInvoice(){
            this.invoiceLoading = true;
            this.$http.get(`personal/invoice`).then(res => {
                if (res.success) {
                    this.invoiceData = res.data;
                    this.invoice_status = res.data.invoice_status;
                    if(res.data.invoice_status==2)
                    {
                        this.loadRecharge();
                        this.loadAddress();
                    }
                }
            }).catch().then(()=>{
                this.invoiceLoading = false
            })
        },
        loadRecharge(){
            this.invoiceLoading = true;
            this.$http.get(`finance/recharge?scope=invoice_able`).then(res => {
                if (res.success) {
                    this.rechargeData = res.data;
                }
            }).catch().then(()=>{
                this.invoiceLoading = false
            }) 
        },
        loadAddress(){
            this.$http.get(`personal/address`).then(res => {
                if (res.success) {
                    this.addressData = res.data;
                }
            })
        },
        handleSelectionChange(v){
           var total = 0; 
           var order = [];
           v.map(v=>{
               total+=Number(v.amount)-Number(v.amount_refunded)
               order.push(v.order_no)
           })

           this.selectedOrder = order;

           this.selected = v.length;
           this.selectedTotal = total;
        },
        handleSubmit(){
            this.submitting = true
            this.$http.post(`personal/invoice/apply`,{order_ids:this.selectedOrder,address_id:this.addressId})
            .then(response => {
               if (response.success) {
                    this.$alert(response.message, "成功", {
                    showCancelButton: false,
                    type:'success',
                        callback: () => {
                            this.$router.push("/finance/invoice_list")
                        }
                    });
               } else {
                this.$alert(response.message, "失败", {
                  type:'error',
                  showCancelButton: false
                })
               }
            })
            .catch().then(()=>{
                this.submitting = false
            })
        }
    }
}
</script>

<style>
.invoice-tips{
    text-align:center;
    color: #757575;
}
.invoice-tips i{
    font-size: 100px;
}
.table {
    border-collapse: collapse;
    width: 100%;
    background-color: #fff;
    font-size: 14px;
    line-height: 1.5em;
}
.number{
    color:#f08c19
}
.table td {
    border-bottom: 1px solid #EEEEEE;
    padding: 8px;
    max-width: 250px;
}
.radio{
    margin: 12px 0;
}
</style>